var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-msg"},[_c('img',{staticClass:"mr-3",attrs:{"src":require("../../../assets/DefaultCloudzet/basic-confused.svg")}}),_c('span',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }